import { useState, useEffect } from "react";
import styles from "./CreateChannelPage.module.css";
import placeholderImage from "../../assets/images/image-upload-placeholder.png";
import api from "../../services/api";
import { ENDPOINTS } from "../../utils/endpoints";
import useDashboardStore from "../../store/dashboardStore";
import { toast } from "react-toastify";

const CreateChannelPage = () => {
  //Left Section Details
  const [sections, setSections] = useState([]); //Contains All Sections
  const { setIsAllChannelScreen, communities, traders, editChannelId } =
    useDashboardStore(); //Contains All Communities
  const [selectedCommunityId, setSelectedCommunityId] = useState(null);
  const [communitySections, setCommunitySections] = useState([]); //Contain only selected community sections
  const [selectedSectionId, setSelectedSectionId] = useState(null);
  const [selectedTraderIds, setSelectedTraderIds] = useState([]); //Containers Ids of all selected Traders
  const [searchTextTrader, setSearchTextTrader] = useState(""); //For Seaching Trader
  const [isChannelPaid, setIsChannelPaid] = useState(true);
  const [wasChannelPaid, setWasChannelPaid] = useState(true); //To store previous form data

  //For Handling Images
  const [bannerFile, setBannerFile] = useState(null);
  const [iconFile, setIconFile] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [iconPreview, setIconPreview] = useState(null);

  //Right Section Details
  const [channelName, setChannelName] = useState("");
  const [channelDescription, setChannelDescription] = useState("");
  const [membershipLink, setMembershipLink] = useState("");
  const [memberships, setMemberships] = useState([]); //Contains All Memberships
  const [selectedMembershipIds, setSelectedMembershipIds] = useState([]); //Containers Ids of all selected Memberships
  const [fixedMembershipIds, setFixedMembershipIds] = useState([]);
  const [searchTextMembership, setSearchTextMembership] = useState(""); //For Seaching Membership

  // Loading states
  const [isSubmitting, setIsSubmitting] = useState(false);

  //Selects Community and resets the sections
  const handleCommunityChange = async (community) => {
    setSelectedSectionId(null);
    setSelectedCommunityId(community.id);
    try {
      const { data } = await api.get(
        ENDPOINTS.GET_COMMUNITY_BY_ID(community.id)
      );
      if (data.success) {
        let communityAvailableSections = data.community.section_ids;
        const filteredSections = sections.filter((section) =>
          communityAvailableSections.includes(section.id)
        );
        setCommunitySections(filteredSections);
      }
    } catch (err) {
      console.error("Failed to fetch sections", err);
      setCommunitySections([]);
    }
  };

  //Select/Deselect Trader
  const handleTraderChange = (trader) => {
    setSelectedTraderIds((prev) =>
      prev.includes(trader.id)
        ? prev.filter((s) => s !== trader.id)
        : [...prev, trader.id]
    );
  };

  //Select/Deselect Membership
  const handleMembershipChange = (membership) => {
    setSelectedMembershipIds((prev) =>
      prev.includes(membership.id)
        ? prev.filter((s) => s !== membership.id)
        : [...prev, membership.id]
    );
  };

  //Banner upload
  const handleBannerUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerFile(file);
      setBannerPreview(URL.createObjectURL(file));
    }
  };

  //Image Upload
  const handleIconUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIconFile(file);
      setIconPreview(URL.createObjectURL(file));
    }
  };
  const handleSubmit = async () => {
    // Prevent double clicks and submissions while already submitting
    if (isSubmitting) return;

    // console.log("=== FORM SUBMISSION DEBUG ===");
    // console.log("selectedSectionId:", selectedSectionId);
    // console.log("selectedCommunityId:", selectedCommunityId);
    // console.log("channelName:", channelName);

    if (
      !channelName ||
      !channelDescription ||
      !selectedCommunityId ||
      !selectedSectionId
    ) {
      toast.error("Please fill all fields.");
      return;
    }

    if (isChannelPaid === true) {
      if (!selectedMembershipIds.length) {
        toast.error("Please fill membership details");
        return;
      }
    }

    //For Create banner and icon is mandatory
    if (editChannelId === null) {
      if (!bannerFile || !iconFile) {
        toast.error("Please upload both images.");
        return;
      }
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("community_id", selectedCommunityId);
      formData.append("section_id", selectedSectionId);

      // console.log("FormData section_id:", selectedSectionId);

      formData.append("name", channelName);
      formData.append("description", channelDescription);
      formData.append("trader_ids", JSON.stringify(selectedTraderIds));
      formData.append("is_paid", isChannelPaid === true ? true : false);
      formData.append("banner", bannerFile);
      formData.append("icon", iconFile);
      formData.append("membership_link", membershipLink);
      formData.append("membership_ids", JSON.stringify(selectedMembershipIds));

      // Log the actual FormData being sent
      // for (let pair of formData.entries()) {
      //   console.log(pair[0] + ": " + pair[1]);
      // }

      const { data } =
        editChannelId !== null
          ? await api.put(
              ENDPOINTS.UPDATE_CHANNEL_BY_ID(editChannelId),
              formData
            )
          : await api.post(ENDPOINTS.CREATE_CHANNEL, formData);

      if (data.success) {
        toast.success(data.message || "Channel created successfully");
        setIsAllChannelScreen();
      } else {
        toast.error(data.message || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error creating channel");
    } finally {
      setIsSubmitting(false);
    }
  };

  // // Create Channel
  // const handleSubmit = async () => {
  //   // Prevent double clicks and submissions while already submitting
  //   if (isSubmitting) return;

  //   if (!channelName || !selectedCommunityId || !selectedSectionId) {
  //     toast.error("Please fill all fields.");
  //     return;
  //   }

  //   if (isChannelPaid === true) {
  //     if (!membershipLink || !selectedMembershipIds.length) {
  //       toast.error("Please fill membership details");
  //       return;
  //     }
  //   }

  //   //For Create banner and icon is mandatory
  //   if (editChannelId === null) {
  //     if (!bannerFile || !iconFile) {
  //       toast.error("Please upload both images.");
  //       return;
  //     }
  //   }

  //   setIsSubmitting(true);

  //   try {
  //     const formData = new FormData();
  //     formData.append("community_id", selectedCommunityId);
  //     formData.append("section_id", selectedSectionId);
  //     formData.append("name", channelName);
  //     formData.append("trader_ids", JSON.stringify(selectedTraderIds));
  //     formData.append("is_paid", isChannelPaid === true ? true : false);
  //     formData.append("banner", bannerFile);
  //     formData.append("icon", iconFile);
  //     formData.append("membership_link", membershipLink);
  //     formData.append("membership_ids", JSON.stringify(selectedMembershipIds));

  //     const { data } =
  //       editChannelId !== null
  //         ? await api.put(
  //             ENDPOINTS.UPDATE_CHANNEL_BY_ID(editChannelId),
  //             formData
  //           )
  //         : await api.post(ENDPOINTS.CREATE_CHANNEL, formData);

  //     if (data.success) {
  //       toast.success(data.message || "Channel created successfully");
  //       setIsAllChannelScreen();
  //     } else {
  //       toast.error(data.message || "Something went wrong");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Error creating channel");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  //Initialize Data
  useEffect(() => {
    const fetchSections = async () => {
      try {
        const { data } = await api.get(ENDPOINTS.GET_ALL_SECTIONS);
        if (data.success) {
          setSections(data.sections);
        }
      } catch (err) {
        console.error("Failed to fetch sections", err);
      }
    };

    const fetchMemberships = async () => {
      try {
        const { data } = await api.get(ENDPOINTS.GET_ALL_MEMBERSHIPS);
        if (data.success) {
          setMemberships(data.memberships);
        }
      } catch (err) {
        console.error("Failed to fetch memberships", err);
      }
    };

    fetchSections();
    fetchMemberships();
  }, []);

  useEffect(() => {
    const resetForm = () => {
      setSelectedCommunityId(null);
      setSelectedSectionId(null);
      setCommunitySections([]);
      setSelectedTraderIds([]);
      setIsChannelPaid(true);
      setWasChannelPaid(true);
      setMembershipLink("");
      setSelectedMembershipIds([]);
      setFixedMembershipIds([]);
      setBannerPreview(null);
      setIconPreview(null);
      setChannelDescription("");
    };

    const prefillFormForEdit = async () => {
      const { data } = await api.get(
        ENDPOINTS.GET_CHANNEL_BY_ID(editChannelId)
      );
      if (data.success) {
        let selectedComm = communities.filter(
          (c) => c.id === data.channel.community.id
        );
        setSelectedCommunityId(selectedComm[0].id);
        const data1 = await api.get(
          ENDPOINTS.GET_COMMUNITY_BY_ID(selectedComm[0].id)
        );
        if (data1.data.success) {
          let communityAvailableSections = data1.data.community.section_ids;
          const filteredSections = sections.filter((section) =>
            communityAvailableSections.includes(section.id)
          );
          setCommunitySections(filteredSections);
        }

        setSelectedSectionId(data.channel.section.id);
        setSelectedTraderIds(data.channel.trader_ids);
        setIsChannelPaid(data.channel.is_paid === 1 ? true : false);
        setWasChannelPaid(data.channel.is_paid === 1 ? true : false);
        setChannelName(data.channel.name);
        setChannelDescription(data.channel.description || "");
        setMembershipLink(data.channel.membership_link);
        setSelectedMembershipIds(data.channel.membership_ids);
        setFixedMembershipIds(data.channel.membership_ids);
        let banner = `${ENDPOINTS.IMAGE_BASE_URL}${data.channel.banner}`;
        let icon = `${ENDPOINTS.IMAGE_BASE_URL}${data.channel.icon}`;
        setBannerPreview(banner);
        setIconPreview(icon);
      }
    };

    if (editChannelId !== null && sections.length > 0) {
      prefillFormForEdit();
    } else if (editChannelId === null) {
      resetForm();
    }
  }, [editChannelId, sections, communities]);

  //Filter Search results
  const filteredTraders = traders.filter((trader) =>
    trader.username.toLowerCase().includes(searchTextTrader.toLowerCase())
  );
  const filteredMemberships = memberships.filter((membership) =>
    membership.label.toLowerCase().includes(searchTextMembership.toLowerCase())
  );

  return (
    <div className={styles.pageWrapper}>
      {/* App Bar */}
      <div className={styles.appbarContainer}>
        <h2 className={styles.appbarTitle}>
          {editChannelId === null ? "Create" : "Update"} Channel
        </h2>
      </div>

      <div className={styles.bodyContainer}>
        {/* Left Section */}
        <div className={styles.leftSection}>
          {/* Select Community */}
          <div className={styles.sectionsWrapper}>
            <label className={styles.inlineLabel}>Select Community</label>
            <div className={styles.sectionsCard}>
              <div className={styles.sectionList}>
                {communities.map((community, i) => (
                  <div className={styles.sectionRow} key={i}>
                    <span className={styles.sectionLabel}>
                      {community.name}
                    </span>
                    <input
                      type="checkbox"
                      className={styles.checkbox}
                      checked={selectedCommunityId === community.id}
                      disabled={isSubmitting || editChannelId !== null}
                      onChange={() => {
                        //Can Change only for create flow
                        if (editChannelId === null) {
                          handleCommunityChange(community);
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Select Section */}
          <div className={styles.sectionsWrapper}>
            <label className={styles.inlineLabel}>Sections List</label>
            <div className={styles.sectionsCard}>
              <div className={styles.sectionList}>
                {communitySections.map((section, i) => (
                  <div className={styles.sectionRow} key={i}>
                    <span className={styles.sectionLabel}>{section.title}</span>
                    <input
                      type="checkbox"
                      className={styles.checkbox}
                      checked={selectedSectionId === section.id}
                      // disabled={isSubmitting || editChannelId !== null}
                      disabled={isSubmitting}
                      onChange={() => {
                        //Can Change only for create flow
                        // if (editChannelId === null) {
                        //   setSelectedSectionId(section.id);
                        // }
                        // console.log("Clicked section:", section.id);
                        // console.log(
                        //   "Current selectedSectionId:",
                        //   selectedSectionId
                        // );
                        setSelectedSectionId(section.id);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Select Traders */}
          <div className={styles.sectionsWrapper}>
            <label className={styles.inlineLabel}>Traders List</label>
            <div className={styles.sectionsCard}>
              <div className={styles.searchBar}>
                <input
                  type="text"
                  placeholder="type in to Filter traders"
                  className={styles.searchInput}
                  value={searchTextTrader}
                  onChange={(e) => setSearchTextTrader(e.target.value)}
                  disabled={isSubmitting}
                />
                <span className={styles.searchIcon}>🔍</span>
              </div>

              <div className={styles.sectionList}>
                {filteredTraders.map((trader, i) => (
                  <div className={styles.sectionRow} key={i}>
                    <span className={styles.sectionLabel}>
                      {trader.username}
                    </span>
                    <input
                      type="checkbox"
                      className={styles.checkbox}
                      checked={selectedTraderIds.includes(trader.id)}
                      onChange={() => handleTraderChange(trader)}
                      disabled={isSubmitting}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Select Channel Type */}
          <div className={styles.liveSessionRow}>
            <label className={styles.inlineLabel}>Channel Type</label>

            <div className={styles.toggleWrapper}>
              <button
                className={`${styles.toggleOption} ${
                  !isChannelPaid ? styles.activeToggle : ""
                }`}
                onClick={() => setIsChannelPaid(false)}
                disabled={
                  isSubmitting
                  // || (editChannelId !== null && wasChannelPaid)
                }
              >
                Free
              </button>
              <button
                className={`${styles.toggleOption} ${
                  isChannelPaid ? styles.activeToggle : ""
                }`}
                onClick={() => setIsChannelPaid(true)}
                disabled={
                  isSubmitting
                  // || (editChannelId !== null && wasChannelPaid)
                }
              >
                Paid
              </button>
            </div>
            {/* <span className={styles.note}>
              <span className={styles.noteHighlight}>NB*</span>: Place below the
              link URL of the membership payment
              <br />
            </span> */}
          </div>
        </div>

        {/* Right Section */}
        <div className={styles.rightSection}>
          {/* Image Upload */}
          <div className={styles.imageSectionWrapper}>
            {bannerPreview && (
              <div className={styles.featuredImageBox}>
                <img
                  src={bannerPreview}
                  alt="Banner Preview"
                  className={styles.featuredImageBox}
                />
                <div className={styles.iconUploadContainer}>
                  <img
                    src={iconPreview || placeholderImage}
                    alt="Icon Preview"
                    className={styles.iconPlaceholder}
                  />
                  <div className={styles.uploadLinks}>
                    <label className={styles.uploadLink}>
                      <span className={styles.plusIcon}>+</span> Choose Featured
                      Image
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleBannerUpload}
                        disabled={isSubmitting}
                      />
                    </label>
                    <label className={styles.uploadLink}>
                      <span className={styles.plusIcon}>+</span> Choose icon
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleIconUpload}
                        disabled={isSubmitting}
                      />
                    </label>
                  </div>
                </div>
              </div>
            )}
            {!bannerPreview && (
              <div className={styles.featuredImageBox}>
                <div className={styles.iconUploadContainer}>
                  <img
                    src={iconPreview || placeholderImage}
                    alt="Icon Preview"
                    className={styles.iconPlaceholder}
                  />
                  <div className={styles.uploadLinks}>
                    <label className={styles.uploadLink}>
                      <span className={styles.plusIcon}>+</span> Choose Featured
                      Image
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleBannerUpload}
                        disabled={isSubmitting}
                      />
                    </label>
                    <label className={styles.uploadLink}>
                      <span className={styles.plusIcon}>+</span> Choose icon
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleIconUpload}
                        disabled={isSubmitting}
                      />
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Channel name */}
          <div className={styles.rowInputGroup}>
            <label className={styles.inlineLabel}>Channel Name</label>
            <input
              type="text"
              value={channelName}
              onChange={(e) => setChannelName(e.target.value)}
              className={styles.textInput}
              disabled={isSubmitting}
            />
          </div>

          {/* Channel Description */}
          <div className={styles.rowInputGroup}>
            <label className={styles.inlineLabel}>Channel Description</label>
            <textarea
              value={channelDescription}
              onChange={(e) => setChannelDescription(e.target.value)}
              className={styles.textInput}
              rows={4}
              disabled={isSubmitting}
            />
          </div>

          {/* Membership link */}
          {/* {isChannelPaid && (
            <div className={styles.rowInputGroup}>
              <label className={styles.inlineLabel}>Membership Link</label>
              <input
                type="text"
                value={membershipLink}
                onChange={(e) => setMembershipLink(e.target.value)}
                className={styles.textInput}
                disabled={isSubmitting}
              />
            </div>
          )} */}

          {/* Select Memberships */}
          {isChannelPaid && (
            <div className={styles.sectionsWrapper}>
              <label className={styles.inlineLabel}>Memberships List</label>
              <div className={styles.sectionsCard}>
                <div className={styles.searchBar}>
                  <input
                    type="text"
                    placeholder="type in to Filter memberships"
                    className={styles.searchInput}
                    value={searchTextMembership}
                    onChange={(e) => setSearchTextMembership(e.target.value)}
                    disabled={isSubmitting}
                  />
                  <span className={styles.searchIcon}>🔍</span>
                </div>

                <div className={styles.sectionList}>
                  {filteredMemberships.map((membership, i) => (
                    <div className={styles.sectionRow} key={i}>
                      <span className={styles.sectionLabel}>
                        {membership.label}
                      </span>
                      <input
                        type="checkbox"
                        className={styles.checkbox}
                        checked={selectedMembershipIds.includes(membership.id)}
                        disabled={
                          isSubmitting
                          // ||
                          // (editChannelId !== null &&
                          //   fixedMembershipIds.includes(membership.id))
                        }
                        onChange={() => handleMembershipChange(membership)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <button
            className={`${styles.submitButton} ${
              isSubmitting ? styles.submitting : ""
            }`}
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span>
                  {editChannelId === null ? "Creating..." : "Updating..."}
                </span>
                <span className={styles.submitIcon}>⟳</span>
              </>
            ) : (
              <>
                <span>Submit Channel</span>
                <span className={styles.submitIcon}>＋</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateChannelPage;
